export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1633_.99fa9c3a.jpg";